import { Text } from '@fhs-legacy/universal-components';

const Counter = Text.withConfig({
  textAlign: 'right',
});

export default Counter;
